import { useDispatch, useSelector } from 'react-redux'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import $t from '../../../i18n'
import NavigationCard from '../Profile/NavigationCard'
import { getIsHmoMember } from '../../../utils/hmoUtils'

import './SettingsAndPreferences.css'
import { event, eventTypes } from '../../../consts/eventConsts'

const SettingsAndPreferences = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector(state => state.profile?.userDetails)
  const isHmoMember = getIsHmoMember(userDetails)
  const languages = useSelector(state => state.app?.languages)
  const handleNavigation = item => {
    if (item?.action) {
      dispatch(
        Actions.createAction(item.action, { from: routes.MENU_ROUTE.PROFILE })
      )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.click,
          eventName: event.clickEvent.click,
          element: item?.label,
        })
      )
    }
  }
  const settingNavigations = [
    {
      label: $t('pages.settingsPreferences.communicationPreferences'),
      action: Actions.COMMUNICATION_PREFERENCES_PRESSED,
      hidden: !isHmoMember,
    },
    {
      label: $t('pages.settingsPreferences.changePassword'),
      action: Actions.CHANGE_PASSWORD_PRESSED,
    },
    {
      label: $t('pages.settingsPreferences.language'),
      action: Actions.LANGUAGE_PRESSED,
      desc: languages?.[userDetails?.language]?.name,
    },
  ]

  return (
    <PageCard
      className="settings-and-preferences-page-card"
      enableBack={true}
      onBack={() =>
        dispatch(
          Actions.createAction(
            Actions.NAVIGATED_TO,
            routes.PROFILE_ROUTE.PROFILE
          )
        )
      }
    >
      <Page title={$t('pages.settingsPreferences.title')}>
        <div className="navigation-container">
          {settingNavigations
            .filter(action => !action.hidden)
            .map((item, index) => (
              <div key={index}>
                <NavigationCard
                  key={index}
                  label={item?.label}
                  desc={item?.desc}
                  className="trackable"
                  handleClick={() => handleNavigation(item)}
                ></NavigationCard>
                <div className="divider"></div>
              </div>
            ))}
        </div>
      </Page>
    </PageCard>
  )
}
export default SettingsAndPreferences
